@if (hasMultiplePractices()) {
  <p class="font-bold">{{ practiceName() }}</p>
}

<mat-form-field subscriptSizing="dynamic">
  <mat-label>Default due date</mat-label>
  <input
    matInput
    type="number"
    min="0"
    [formControl]="dueDateDays"
    [disabled]="saving()"
    (change)="onDueDateDaysChange()"
  />
  <span matTextSuffix>&nbsp; days after issue</span>
</mat-form-field>
